import edit from "../edit";
import metadata from "./block.json";

const __ = Drupal.t;

const { category, attributes, supports } = metadata;

const icon = (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="64px"
		height="80px"
		viewBox="0 0 64 80"
	>
		<title>{__("Polar Area Chart")}</title>
		<path fill="none" d="M35.001 35H35zM35.001 35H35zM35.001 35H35z" />
		<path d="M53.966 34c-.323-6.035-3.543-11.603-8.625-14.913l3.022-5.235-.864-.5A24.978 24.978 0 0 0 35 10a24.982 24.982 0 0 0-11.616 2.88l-3.017-5.225-.866.502C9.939 13.689 4 23.975 4 35v1h18.043a13.045 13.045 0 0 0 5.618 9.713l-3.019 5.229.864.5A18.987 18.987 0 0 0 35 54c2.986 0 5.942-.722 8.612-2.086l3.022 5.234.866-.502C55.211 52.187 60 43.892 60 35v-1h-6.034zm-1.996 0H36.732l7.611-13.184c4.469 2.951 7.309 7.86 7.627 13.184zM24.378 14.602a22.98 22.98 0 0 1 21.244 0L35 33l-6.573-11.385-4.049-7.013zm-4.732-4.198L33.268 34H6.018c.335-9.601 5.468-18.489 13.628-23.596zM24.046 36h9.222l-3.419 5.922-1.187 2.056A11.053 11.053 0 0 1 24.046 36zm18.568 14.186c-4.73 2.379-10.497 2.378-15.228.001l1.983-3.435 1.328-2.299L35.001 37l6.146 10.644 1.467 2.542zm4.74 4.21L36.733 36h21.246c-.33 7.466-4.314 14.366-10.625 18.396z" />
		<path fill="none" d="M35.001 35H35z" />
	</svg>
);

const settings = {
	...metadata,
	title: __("Polar Area Chart"),
	description: __(
		"Display your data in a Polar Area Chart. Ideal for single and multiple datasets.",
	),
	icon,
	category,
	supports,
	attributes,
	edit,
	save: () => null,
};

export { settings as polarArea };
